<template>
  <SvgIcon
    class="blend-type-glyph"
    :content="iconAssetMarkup"
    alt=""
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SvgIcon from '@/components/common/SvgIcon.vue';
import chamferAngleDistanceIcon from '@/assets/icon/chamfer_angle_distance.svg?raw';
import chamferDistanceDistanceIcon from '@/assets/icon/chamfer_distance_distance.svg?raw';
import chamferFaceFaceIcon from '@/assets/icon/chamfer_face_face.svg?raw';
import chamferOffsetFaceIcon from '@/assets/icon/chamfer_offset_face.svg?raw';
import chamferVertexIcon from '@/assets/icon/chamfer_vertex.svg?raw';
import filletConstantSizeIcon from '@/assets/icon/fillet_constant_size.svg?raw';
import filletFaceIcon from '@/assets/icon/fillet_face.svg?raw';
import filletVariableSizeIcon from '@/assets/icon/fillet_variable_size.svg?raw';

type BlendTypeGlyphKey =
  | 'fillet-constant'
  | 'fillet-variable'
  | 'fillet-face'
  | 'chamfer-angle-distance'
  | 'chamfer-distance-distance'
  | 'chamfer-vertex'
  | 'chamfer-offset-face'
  | 'chamfer-face-face';

const props = defineProps<{
  iconKey: BlendTypeGlyphKey;
}>();

/**
 * 圆角/倒角类型图标资源映射。
 *
 * 所有类型图标都以独立 SVG 文件维护，组件只负责静态资源选择；
 * 这样新增特征类型时不会继续把绘制细节耦合进 Vue 模板。
 */
const BLEND_ICON_ASSET_MARKUP_MAP = {
  'fillet-constant': filletConstantSizeIcon,
  'fillet-variable': filletVariableSizeIcon,
  'fillet-face': filletFaceIcon,
  'chamfer-angle-distance': chamferAngleDistanceIcon,
  'chamfer-distance-distance': chamferDistanceDistanceIcon,
  'chamfer-vertex': chamferVertexIcon,
  'chamfer-offset-face': chamferOffsetFaceIcon,
  'chamfer-face-face': chamferFaceFaceIcon,
} satisfies Record<BlendTypeGlyphKey, string>;

/**
 * 当前图标对应的静态资源原始标记。
 *
 * @returns 图标资源 SVG 原始标记。
 */
const iconAssetMarkup = computed(() => BLEND_ICON_ASSET_MARKUP_MAP[props.iconKey]);
</script>

<style scoped>
.blend-type-glyph {
  display: block;
  width: 28px;
  height: 28px;
}
</style>
